import React from 'react';
import { Box, Text } from 'rebass/styled-components';
import PropTypes from 'prop-types';

export const BillingSupportContact = ({ email, variant }) => {
  const mailto = (
    <Text as="a" href={`mailto:${email}`} color="text.main" fontWeight="medium">
      {email}
    </Text>
  );

  if (variant === 'unavailable') {
    return (
      <Box
        mt="40px"
        p="24px"
        sx={{
          borderRadius: '4px',
          border: '1px solid',
          borderColor: 'border.subtle',
          fontSize: '14px',
          textAlign: 'center',
        }}
      >
        <Text mb="8px" display="block">
          Billing details are not currently available here.
        </Text>
        <Text>For invoices or billing questions, please contact {mailto}.</Text>
      </Box>
    );
  }

  return (
    <Box mt="32px" fontSize="14px" lineHeight="20px" color="text.main">
      For payment method updates, billing information, or invoices, contact {mailto}.
    </Box>
  );
};

BillingSupportContact.propTypes = {
  email: PropTypes.string.isRequired,
  variant: PropTypes.oneOf(['unavailable', 'eligible']).isRequired,
};
